import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';

const rules = ({ theme }) => ({
  fontWeight: '600',
  marginBottom: theme.margin.medium,
  maxWidth: '300px',
  textAlign: 'center',
});

const Message = ({ children }) => {
  const { css } = useFela();

  return (
    <div className={css(rules)}>
      {children}
    </div>
  );
};

Message.propTypes = {
  children: PropTypes.node,
};

export default React.memo(Message);
